goog.provide('el8.util.amplitude.patientFormHelpers');

goog.require('el8.util.amplitude.helpers');

/**
 * Amplitude logging for opening the dialog to send patient form requests
 *
 * @param {string} source - the place in the UI where the dialog is opened from
 */
el8.util.amplitude.logOpenSendFormsDialog = function() {
  var source = "chart";
  if (el8Globals.APP === "home") {
    source = "practice home";
  }
  el8.util.amplitude.logEvent('View dialog for sending patient forms without appointment', { 'source': source });
};


/**
 * Amplitude logging for when a staff member marks a form as reviewed.
 */
el8.util.amplitude.logStaffFormReview = function() {
  el8.util.amplitude.logEvent('Staff marked form as reviewed');
}


/**
 * Amplitude logging for when any member marks a form as reviewed.
 */
el8.util.amplitude.logFormReview = function() {
  el8.util.amplitude.logEvent('User marked form as reviewed');
}
